export default __webpack_public_path__ + "static/media/july-min.378c658b.jpg";